import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import React, { Component } from 'react'

export default class MobileHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      heading: props.name
    }
  }

  handleBackClick = () => {
    if (this.props.onBackClick) {
      this.props.onBackClick()
    }
  }

  render() {
    return (
      <div className="mobileHeaderWrapper">
        <div onClick={this.handleBackClick} style={{ cursor: 'pointer' }}>
          <ArrowBackIcon style={{ width: '24px', height: '24px', color: '#2e3192' }} />
        </div>
        <div className="mobileHeaderTitle">{this.state.heading} </div>
      </div>
    )
  }
}
